import React from 'react';
import HtmlToReact from 'html-to-react';
import { NotificationsAnchor } from './notifications-anchor';
import { NotificationsSpan } from './notifications-span';
import { Language } from 'enums';

export const parseDate = (rawDate: string) => {
  return new Date(rawDate).toLocaleString('cs');
};

const isValidNode = () => true;
var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

const processingInstructions = (addTab: any, cls: Record<string, string>) => [
  {
    // Custom <a> processing
    shouldProcessNode: function (node: { name?: string }) {
      return node?.name === 'a';
    },
    processNode: NotificationsAnchor(addTab, cls),
  },
  {
    // Custom <span> processing
    shouldProcessNode: function (node: { name?: string }) {
      return node?.name === 'span';
    },
    processNode: NotificationsSpan(parseDate, cls),
  },
  {
    // Anything else
    shouldProcessNode: function () {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode,
  },
];

const htmlToReactParser = new HtmlToReact.Parser();
export const parseHtmlMessage = (
  contentRaw: string,
  addTab: any,
  cls: Record<string, string>
) => {
  const reactComponent: JSX.Element = htmlToReactParser.parseWithInstructions(
    contentRaw,
    isValidNode,
    processingInstructions(addTab, cls)
  );

  return reactComponent;
};

export const getNotificationLanguageFromSelectedLocale = (locale?: string) => {
  switch (locale) {
    case 'cs':
      return Language.CZ;
    case 'en':
      return Language.EN;
    default:
      return Language.CZ;
  }
};
